import dayjs from "dayjs";

/** Sentinel for "All" / empty selection in ops dashboard filters (matches index.tsx). */
export const EMPTY_FILTER_VALUE = "___EMPTY___";

export const getDefaultDateRange = () => {
  const previousMonth = dayjs().subtract(1, "month");

  return {
    startDate: previousMonth,
    endDate: previousMonth,
    label: `${previousMonth.format("MMM YYYY")} - ${previousMonth.format(
      "MMM YYYY"
    )}`,
  };
};

export const formatValue = (value: number | undefined) => {
  return (value ?? 0).toLocaleString("en-US");
}
